module.exports = __webpack_public_path__ + "f8cfdd8ddd5a19b7a76bc094b01ac1ab.svg";